<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-monitor"></i> {{ isEdit ? '编辑广告' : '新增广告' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="100px"
        label-position="right"
        size="small"
      >
        <!-- 基本信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-info"></i>
            <span>基本信息</span>
          </div>
          
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="广告标题" prop="ad_name">
                <el-input 
                  v-model="ruleForm.ad_name" 
                  placeholder="请输入广告标题"
                  prefix-icon="el-icon-edit"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="广告位置" prop="position_id">
                <el-select 
                  v-model="ruleForm.position_id" 
                  placeholder="请选择广告位置"
                  clearable
                  style="width: 100%;"
                >
                  <el-option 
                    v-for="item in cateMenus" 
                    :key="item.id" 
                    :label="item.pid > 0 ? '|-- ' + item.name : item.name" 
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属区域">
                <el-cascader
                  ref="cascaderAddr"
                  v-model="areaList"
                  :props="propsdata"
                  :key="isResouceone"
                  @change="handleChangeAddress"
                  placeholder="请选择区域"
                  clearable
                  style="width: 100%;"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="所属商家">
                <el-input 
                  v-model="ruleForm.shop_name" 
                  placeholder="请选择所属商家"
                  prefix-icon="el-icon-shop"
                  suffix-icon="el-icon-arrow-down"
                  @focus="chooseM"
                  readonly
                  clearable
                  @clear="clearShop"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开始日期">
                <el-date-picker 
                  v-model="addForm.start_time" 
                  type="date" 
                  placeholder="选择开始日期"
                  value-format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  clearable
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="过期时间">
                <el-date-picker 
                  v-model="addForm.end_time" 
                  type="date" 
                  placeholder="选择过期时间"
                  value-format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  clearable
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 广告图片区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-picture"></i>
            <span>广告图片</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="图片预览" class="image-preview-item">
                <div class="image-preview" @click="showImgDoc(1)">
                  <i v-if="!ruleForm.ad_code" class="el-icon-camera preview-icon"></i>
                  <el-image 
                    v-if="ruleForm.ad_code" 
                    class="preview-image" 
                    :src="ruleForm.ad_code" 
                    fit="cover"
                  ></el-image>
                  <div class="preview-tip" v-if="!ruleForm.ad_code">
                    点击上传图片
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="图片URL">
                <el-input 
                  v-model="ruleForm.ad_code" 
                  placeholder="图片地址会自动生成"
                  prefix-icon="el-icon-link"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="上传图片">
                <div class="upload-wrapper">
                  <el-upload
                    class="image-uploader"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    :limit="1"
                    :on-exceed="handleFileExceed"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，建议尺寸 800x600，不超过2MB</div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 广告详情区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-document"></i>
            <span>广告详情</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="广告链接">
                <el-input 
                  v-model="ruleForm.ad_link" 
                  placeholder="请输入广告跳转链接"
                  prefix-icon="el-icon-link"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="广告内容" class="editor-item">
                <div class="editor-wrapper">
                  <Toolbar
                    style="border-bottom: 1px solid #e4e7ed"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  />
                  <Editor
                    style="height: 350px; overflow-y: auto;"
                    v-model="html"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">保存</el-button>
          <el-button @click="resetForm" icon="el-icon-refresh-left" size="medium">重置</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 商家选择弹框 - 修复事件监听 -->
    <eShop 
      :formData="formData" 
      :visible.sync="visible" 
      :title="title" 
      @eventChoose="handleShopSelected"
      :closeForm="closeForm" 
    />
    
    <!-- 图片选择弹框 -->
    <eDocList 
      :formData="formData1" 
      :visible.sync="visible1" 
      :title="title1" 
      :closeForm="closeForm1" 
    />
  </div>
</template>

<script>
import eDocList from "../common/eDocList";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import axios from 'axios'
import moment from 'moment'
import eShop from "../common/eShopList";
import CryptoJS from "crypto-js"

export default {
  name: 'adForm',
  components: { Editor, Toolbar, eShop, eDocList },
  data() {
    const _this = this
    
    return {
      formData: {},
      title: '',
      visible: false,
      
      formData1: {},
      title1: '',
      visible1: false,
      type_img: 1,
      
      access_token: sessionStorage.getItem('token'),
      company_id: sessionStorage.getItem('company_id'),
      baseUrl: '/api/',
      fileList: [],
      isShowShop: false,
      
      ruleForm: {
        url: '',
        shop_name: '',
        shop_id: '',
        ad_id: '',
        ad_name: '',
        ad_link: '',
        position_id: '',
        ad_code: '',
      },
      
      addForm: {
        start_time: "",
        end_time: "",
        province_id: '',
        city_id: '',
        district_id: ''
      },
      
      cateMenus: [],
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入广告内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      mode: 'default',
      
      rules: {
        ad_name: [
          { required: true, message: "请输入广告标题", trigger: 'blur' },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: 'blur' }
        ],
        position_id: [
          { required: true, message: "请选择广告位置", trigger: 'change' }
        ]
      },
      
      areaList: [],
      isResouceone: false,
      
      propsdata: {
        lazy: true,
        lazyLoad(node, resolve) {
          setTimeout(() => {
            if (node.level == 0) {
              _this.$axios.regionList({
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: 1
              }).then((res) => {
                if (res.code == 200) {
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                  resolve(nodes)
                }
              })
            }
            if (node.level == 1) {
              _this.$axios.regionList({
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: node.value
              }).then((res) => {
                if (res.code == 200) {
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                  resolve(nodes)
                }
              })
            }
            if (node.level == 2) {
              _this.$axios.regionList({
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: node.value
              }).then((res) => {
                if (res.code == 200) {
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                    leaf: true,
                  }))
                  resolve(nodes)
                }
              })
            }
          }, 100)
        },
      }
    }
  },
  computed: {
    isEdit() {
      return this.ruleForm.ad_id && this.ruleForm.ad_id > 0
    }
  },
  mounted() {
    this.getAdPoistionTree()
    const ad_id = this.$route.query.ad_id
    if (ad_id && !isNaN(ad_id) && ad_id > 0) {
      this.ruleForm.ad_id = ad_id
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    // 商家选择回调 - 修复：接收返回的参数
    handleShopSelected(id, name, item) {
      console.log('选中的商家:', id, name, item)
      this.ruleForm.shop_id = id
      this.ruleForm.shop_name = name
      this.visible = false
      this.$message.success(`已选择商家：${name}`)
    },
    
    // 清空商家选择
    clearShop() {
      this.ruleForm.shop_id = ''
      this.ruleForm.shop_name = ''
    },
    
    showImgDoc(type) {
      this.type_img = type
      this.title1 = "图片选择"
      this.visible1 = true
    },
    
    closeForm1() {
      if (this.type_img == 1 && this.formData1 && this.formData1.url) {
        this.ruleForm.ad_code = this.formData1.url
        // 更新文件列表
        this.fileList = [{
          name: '广告图片',
          url: this.formData1.url
        }]
      }
      this.visible1 = false
    },
    
    closeForm() {
      // 这个方法保留用于兼容，但主要使用 handleShopSelected
      this.visible = false
    },
    
    chooseM() {
      this.title = '选择商家'
      this.visible = true
    },
    
    handleFileExceed() {
      this.$message.warning('只能上传一个图片文件')
    },
    
    handleChangeAddress() {
      const checkedNode = this.$refs["cascaderAddr"].getCheckedNodes()
      if (checkedNode && checkedNode[0]) {
        const path = checkedNode[0].path
        if (path && path.length >= 1) this.addForm.province_id = path[0]
        if (path && path.length >= 2) this.addForm.city_id = path[1]
        if (path && path.length >= 3) this.addForm.district_id = path[2]
      }
    },
    
    submitForm() {
      let _this = this
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          let params = {
            ad_id: _this.ruleForm.ad_id || '',
            shop_id: _this.ruleForm.shop_id || '',
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            ad_name: _this.ruleForm.ad_name,
            position_id: _this.ruleForm.position_id,
            ad_code: _this.ruleForm.ad_code,
            link: _this.ruleForm.ad_link,
            content: _this.html,
            province_id: _this.addForm.province_id,
            city_id: _this.addForm.city_id,
            district_id: _this.addForm.district_id,
            start_time: _this.addForm.start_time
          }
          
          const apiMethod = _this.ruleForm.ad_id ? this.$axios.adUpdate : this.$axios.adSave
          apiMethod(params).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              setTimeout(() => {
                this.$router.push('/adList')
              }, 1500)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    
    getOne() {
      let _this = this
      let param = {
        access_token: _this.access_token,
        company_id: _this.company_id,
        ad_id: _this.ruleForm.ad_id
      }
      this.$axios.adOne(param).then((res) => {
        if (res.code == 200) {
          let item = res.data
          _this.addForm.province_id = item.province_id
          _this.addForm.city_id = item.city_id
          _this.addForm.district_id = item.district_id
          if (item.province_id && item.city_id && item.district_id) {
            _this.areaList = [item.province_id, item.city_id, item.district_id]
          }
          _this.ruleForm.ad_name = item.ad_name
          _this.ruleForm.ad_id = item.ad_id
          _this.ruleForm.position_id = item.position_id
          _this.ruleForm.ad_code = item.ad_code
          _this.ruleForm.shop_id = item.shop_id
          _this.ruleForm.shop_name = item.shop != null ? item.shop.name : ''
          _this.ruleForm.ad_link = item.link || ''
          _this.html = item.content || ''
          _this.addForm.start_time = item.start_time ? moment(item.start_time * 1000).format('YYYY-MM-DD') : ''
          
          if (_this.ruleForm.ad_code && _this.ruleForm.ad_code !== '') {
            _this.fileList = [{
              name: _this.ruleForm.ad_name || '广告图片',
              url: _this.ruleForm.ad_code
            }]
          }
        }
      })
    },
    
    async uploadFile(item) {
      let _this = this
      let file = item.raw
      
      // 文件校验
      if (!this.handleBeforeUpload(file)) return
      
      let file_md5, file_sha1
      await this.calculateMD5(file).then(md5 => {
        file_md5 = md5
      })
      await this.calculateSHA1(file).then(sha1 => {
        file_sha1 = sha1
      })
      
      const fileName = file.name
      const fileSize = file.size
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1)
      
      let param_1 = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: fileSize
      }
      
      this.$axios.uploadOne(param_1).then(res => {
        if (res.code == 200) {
          _this.ruleForm.ad_code = res.data.url
          _this.fileList = [{ name: fileName, url: res.data.url }]
          _this.$message.success('图片上传成功')
        } else {
          this.uploadToOSS(file, fileName, fileSize, fileExtension, file_md5, file_sha1)
        }
      })
    },
    
    uploadToOSS(file, fileName, fileSize, fileExtension, file_md5, file_sha1) {
      let _this = this
      this.$axios.getAliJsonCmp({}).then(res => {
        let data = res['data']
        let suffix = this.get_suffix(file.name)
        let autoname = this.Ymdhis()
        let key = data['dir']
        let host = data['host']
        let path = data['path'] != null && data['path'] != undefined ? data['path'] : ''
        
        let request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + autoname + suffix)
        request.append("policy", data['policy'])
        request.append("OSSAccessKeyId", data['accessid'])
        request.append("success_action_status", '200')
        request.append("callback", data['callback'])
        request.append("Signature", data['signature'])
        request.append('file', file)
        
        axios.post(host, request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          var fileurl = res.data.filename
          var fullurl = host + '/' + fileurl
          _this.ruleForm.ad_code = fullurl
          _this.fileList = [{ name: fileName, url: fullurl }]
          _this.$message.success('图片上传成功')
          
          let upload_params = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            name: fileName,
            size: fileSize,
            ext: fileExtension,
            md5: file_md5,
            sha1: file_sha1,
            path: fileurl,
            url: fullurl,
            status: 1,
          }
          _this.$axios.uploadSave(upload_params)
        }).catch(error => {
          console.log(error)
          _this.$message.error('上传失败')
        })
      })
    },
    
    readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsBinaryString(file)
      })
    },
    
    async calculateMD5(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.MD5(words).toString()
      })
    },
    
    async calculateSHA1(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.SHA1(words).toString()
      })
    },
    
    resetForm() {
      this.$refs.formForRef.resetFields()
      this.html = ''
      this.fileList = []
      this.areaList = []
      this.ruleForm.shop_id = ''
      this.ruleForm.shop_name = ''
      this.ruleForm.ad_code = ''
    },
    
    goBack() {
      this.$router.push('/adList')
    },
    
    handleBeforeUpload(file) {
      if (!file) return false
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    
    getAdPoistionTree() {
      let param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.adPositionTable(param).then((res) => {
        if (res.code == 200) {
          this.cateMenus = res.data || []
        }
      })
    },
    
    uploadImg(file, insertFn) {
      let _this = this
      this.$axios.getAliJson({}).then(res => {
        let data = res['data']
        let suffix = _this.get_suffix(file.name)
        let autoname = _this.Ymdhis()
        let key = data['dir']
        let host = data['host']
        
        let request = new FormData()
        request.append('name', file.name)
        request.append("key", key + 'editor/' + autoname + suffix)
        request.append("policy", data['policy'])
        request.append("OSSAccessKeyId", data['accessid'])
        request.append("success_action_status", '200')
        request.append("callback", data['callback'])
        request.append("Signature", data['signature'])
        request.append('file', file)
        
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          var fileurl = res.data.filename
          var fullurl = host + '/' + fileurl
          setTimeout(function() {
            insertFn(fullurl)
          }, 500)
          _this.$message.success('图片上传成功')
        }).catch(error => {
          console.log(error)
          _this.$message.error('图片上传失败')
        })
      })
    },
    
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    
    get_suffix(filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos != -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    
    Ymdhis() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      return '' + year + month + day + hour + minute + second
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
// ... 保持原有样式不变 ...
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

.form-section {
  margin-bottom: 28px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 20px;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.el-form-item .el-input__inner,
.el-form-item .el-textarea__inner,
.el-form-item .el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
}

.el-form-item .el-input__inner:focus,
.el-form-item .el-textarea__inner:focus,
.el-form-item .el-select .el-input__inner:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

.image-preview-item .el-form-item__content {
  line-height: 1;
}

.image-preview {
  width: 150px;
  height: 150px;
  border: 2px dashed #e4e7ed;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fc;
  overflow: hidden;
  
  &:hover {
    border-color: #1677ff;
    background: #f0f7ff;
    
    .preview-icon {
      color: #4096ff;
    }
  }
  
  .preview-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .preview-tip {
    font-size: 12px;
    color: #8c8f98;
  }
}

.upload-wrapper {
  .image-uploader .el-upload-dragger {
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    background: #fafbfc;
    width: 100%;
    height: 140px;
    
    &:hover {
      border-color: #1677ff;
      background: #f0f7ff;
    }
    
    .el-icon-upload {
      font-size: 40px;
      color: #1677ff;
      margin-top: 28px;
    }
    
    .el-upload__text {
      color: #8c8f98;
      
      em {
        color: #1677ff;
      }
    }
  }
  
  .el-upload-list__item {
    border-radius: 8px;
    transition: all 0.2s;
    
    &:hover {
      background: #f5f7fa;
    }
  }
  
  .el-upload__tip {
    font-size: 12px;
    color: #8c8f98;
    margin-top: 8px;
  }
}

.editor-item .el-form-item__content {
  line-height: 1;
}

.editor-wrapper {
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
  
  &:focus-within {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>

<style>
.alipay-card .el-card__body {
  padding: 20px 24px;
}

.el-form-item__label {
  font-weight: 500;
}

.input__inner {
  color: #333;
}

.w-e-modal {
  z-index: 999 !important;
  left: 300px !important;
  top: 300px !important;
}
</style>